module.exports = __webpack_public_path__ + "static/media/particles1.615c05d7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/particles1.svg
// module id = 166
// module chunks = 0